import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { fetchMe, logout as apiLogout, API } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  const checkAuth = useCallback(async () => {
    setLoading(true);
    try {
      const me = await fetchMe();
      setUser(me);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Kicks off portable Google OAuth. The backend redirects the browser to Google,
  // Google redirects back to /api/auth/google/callback, and the backend then
  // redirects to /admin with an httpOnly session cookie set.
  const login = useCallback(() => {
    window.location.href = `${API}/auth/google/login`;
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiLogout();
    } catch (e) {
      // ignore
    }
    setUser(null);
  }, []);

  const value = {
    user,
    loading,
    initialized,
    isAuthenticated: !!user,
    isAdmin: !!user && user.role === "super_admin",
    login,
    logout,
    refresh: checkAuth,
    setUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
